import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateCalllogStatusSaga } from "src/store/calllog-status/saga";
import { CalllogStatusDetailDto } from "src/store/calllog-status/type";
import * as Yup from "yup";

const ClientCalllogStatusEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: CalllogStatusDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("ClientCalllogStatus.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          Translates: data.Translates,
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("ClientCalllogStatus.Name").toString(),
          },
        ]}
        onSubmit={(values) => {
          dispatch(
            updateCalllogStatusSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
      />
    </React.Fragment>
  );
};
export default ClientCalllogStatusEditForm;
